import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircleMore, PhoneCall, X } from "lucide-react";

export function FloatingActions({ siteData }) {
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <>
      <div className="fixed inset-x-0 bottom-4 z-40 flex justify-center px-4" data-testid="floating-actions-bar">
        <div className="flex w-full max-w-md items-center justify-between rounded-full border border-primary/20 bg-white/95 px-3 py-3 shadow-[0_18px_50px_rgba(0,0,0,0.18)] backdrop-blur-xl">
          <a
            className="inline-flex items-center gap-2 rounded-full bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5"
            data-testid="floating-call-button"
            href={`tel:${siteData.phone}`}
          >
            <PhoneCall className="h-4 w-4" />
            Call {siteData.phone}
          </a>
          <button
            className="inline-flex items-center gap-2 rounded-full border border-primary/20 px-4 py-3 text-sm font-semibold text-foreground transition-colors hover:bg-primary/10"
            data-testid="floating-chat-toggle-button"
            onClick={() => setIsChatOpen((value) => !value)}
            type="button"
          >
            {isChatOpen ? <X className="h-4 w-4" /> : <MessageCircleMore className="h-4 w-4" />}
            Live chat
          </button>
        </div>
      </div>

      {isChatOpen && (
        <div className="fixed bottom-24 right-4 z-40 w-[min(92vw,360px)] rounded-[2rem] border border-primary/15 bg-white p-6 shadow-[0_24px_80px_rgba(16,24,40,0.18)]" data-testid="floating-chat-panel">
          <p className="text-sm font-semibold uppercase tracking-[0.25em] text-primary" data-testid="floating-chat-label">
            Live chat placeholder
          </p>
          <h3 className="mt-3 text-2xl font-bold text-foreground" data-testid="floating-chat-title">
            Want a faster answer?
          </h3>
          <p className="mt-3 text-sm text-muted-foreground" data-testid="floating-chat-message">
            We can connect a full live chat tool next. For now, call us directly or send your details through the quote form.
          </p>
          <div className="mt-5 flex flex-wrap gap-3">
            <a className="rounded-full bg-primary px-4 py-3 text-sm font-semibold text-primary-foreground" data-testid="floating-chat-call-link" href={`tel:${siteData.phone}`}>
              Call now
            </a>
            <Link className="rounded-full border border-primary/20 px-4 py-3 text-sm font-semibold text-foreground" data-testid="floating-chat-contact-link" to="/contact">
              Go to contact page
            </Link>
          </div>
        </div>
      )}
    </>
  );
}